<template>
  <svg :width="width" :height="height" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.6667 3.33325H3.33341C2.40841 3.33325 1.67508 4.07492 1.67508 4.99992L1.66675 14.9999C1.66675 15.9249 2.40841 16.6666 3.33341 16.6666H16.6667C17.5917 16.6666 18.3334 15.9249 18.3334 14.9999V4.99992C18.3334 4.07492 17.5917 3.33325 16.6667 3.33325ZM15.8334 14.9999H4.16675C3.70841 14.9999 3.33341 14.6249 3.33341 14.1666V9.99992H16.6667V14.1666C16.6667 14.6249 16.2917 14.9999 15.8334 14.9999ZM3.33341 6.66659H16.6667V4.99992H3.33341V6.66659Z"
      fill-rule="evenodd"
      clip-rule="evenodd"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '' },
    height: { type: String, default: '' },
    color: { type: String, default: '' },
  },
}
</script>
